<template>
   <div class="row">
      <div id="search-nav" class="col-12 d-block btn-group dropup">
         <button type="button" class="btn btn-primary dropdown-toggle d-block d-lg-none" :class="pesquisa.resultado.length > 0 ? '' : 'empty'" data-toggle="dropdown" aria-expanded="false">
            <i class="far fa-search font-17"></i>
         </button>
         <div class="card mb-2 dropdown-menu dropdown-menu-left">
            <div class="card-body pb-0">
               <div class="row m-0">
                  <div class="col-12 col-sm-12 col-md-9 mb-3 px-1">
                     <label><i class="far fa-folder font-13 color-theme mr-1"></i> Nome da pasta</label>
                     <input type="text" class="form-control rounded" v-model="pesquisa.valor" maxlength="200" @keyup.enter="searchArquivos" placeholder="Busque por nome da pasta" />
                  </div>
                  <div class="col-6 col-md-1 mb-3 px-1 align-self-end">
                     <button type="button" class="btn btn-primary w-100 rounded" @click="searchArquivos">
                        <i class="fa fa-search font-13 mr-1"></i>
                     </button>
                  </div>
                  <div class="col-6 col-md-2 mb-3 px-1 align-self-end">
                     <button type="button" class="btn btn-primary w-100 rounded" @click="addPasta">
                        <i class="fa fa-plus font-13 mr-1"></i> Adicionar
                     </button>
                  </div>
               </div>
            </div>
         </div>
      </div>

      <div class="col-12" v-if="pesquisa.resultado.length > 0">
			<div class="card mb-0">
				<div class="card-body">
					<div class="row px-1">
						<div class="col mb-2 align-self-center">
							<div class="limitador-1 mb-1"><i class="fas fa-angle-right color-theme me-1"></i> {{ pesquisa.resultado.length == 100 ? 'Limitado a ': '' }} {{ pesquisa.resultado.length }} resultado(s)</div>
						</div>
					</div>
               <div class="cards-2">
                  <pasta v-for="(pasta, index) in pesquisa.resultado" :key="index" :pasta="pasta" :index="index" @deletePasta="deletePasta($event)" @abrirPasta="abrirPasta($event)" />
               </div>
				</div>
			</div>
      </div>
      <div class="col-12 my-5 text-center" v-else>Nenhum resultado encontrado</div>

      <!-- modalAddPasta -->
      <div class="modal fade" id="modalAddPasta" tabindex="-1" data-backdrop="static" aria-labelledby="modalAddPastaLabel" aria-hidden="true">
         <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" role="document">
            <div class="modal-content">
               <div class="modal-header">
                  <h5 class="modal-title h4" id="modalAddPastaLabel">Adicionar pasta</h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
               </div>
               <div class="modal-body">
                  <div class="row m-0">
                     <div class="col-xl-12 px-1">
                        <div class="card mb-0">
                           <div class="card-body">
                              <div class="row m-0">
                                 <div class="col-12 px-1 mb-1">
                                    <h6 class="text-center mb-0">Informações da pasta</h6>
                                    <hr class="mb-2">
                                 </div>
                                 <div class="col-8 mb-3 px-1">
                                    <label class="mb-1"><i class="far fa-folder font-13 color-theme mr-1"></i> Nome da pasta *</label>
                                    <input type="text" class="form-control rounded" v-model="pasta.nome" maxlength="200" />
                                 </div>
                                 <div class="col-xl-4 px-1 mb-3">
                                    <label class="mb-1"><i class="far fa-calendar color-theme font-13 mr-1"></i> Ano dos documentos</label>
                                    <input type="text" class="form-control rounded" v-model="pasta.anoReferencia" v-mask="'####'" maxlength="4" />
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="modal-footer">
                  <button type="button" class="btn btn-round btn-primary" @click="savePasta">Salvar</button>
                  <button type="button" class="btn btn-round btn-secondary" data-dismiss="modal">Fechar</button>
               </div>
            </div>
         </div>
      </div>

      <!-- modalPastasMensais -->
      <div class="modal fade" id="modalPastasMensais" tabindex="-1" data-backdrop="static" aria-labelledby="modalPastasMensaisLabel" aria-hidden="true">
         <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" role="document">
            <div class="modal-content h-100">
               <div class="modal-header">
                  <h5 class="modal-title h4" id="modalPastasMensaisLabel">Pastas Mensais</h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
               </div>
               <div class="modal-body h-100">
                  <div class="row m-0 h-100">
                     <div class="col-xl-12 px-1">
                        <div class="card mb-0 h-100">
                           <div class="card-body">
                              <!-- Nav tabs -->
                              <ul class="nav nav-tabs" id="pastasMensaisTabs" role="tablist">
                                 <li class="nav-item" v-for="(pasta, index) in listaPastas" :key="index">
                                    <a class="nav-link" :class="index === 0 ? 'active' : ''" :id="'tab-' + index" data-toggle="tab" :href="'#pasta-' + index" role="tab" :aria-controls="'pasta-' + index" :aria-selected="index === 0">
                                       {{ getMesNome(pasta.nome) }}
                                    </a>
                                 </li>
                              </ul>
                              
                              <!-- Tab panes -->
                              <div class="tab-content" id="pastasMensaisTabContent">
                                 <div class="tab-pane fade" :class="index === 0 ? 'show active' : ''" :id="'pasta-' + index" role="tabpanel" :aria-labelledby="'tab-' + index" v-for="(pasta, index) in listaPastas" :key="index">
                                    <div class="mt-0">
                                       <div class="row">
                                          <div class="col-12">
                                             <div class="pasta-header">
                                                <div class="d-flex justify-content-between align-items-center">
                                                   <div class="d-flex align-items-center">
                                                      <i class="far fa-folder color-theme mr-2"></i>
                                                      <h6 class="mb-0">{{ pasta.nome }}</h6>
                                                   </div>
                                                   <div class="d-flex align-items-center">
                                                      <!-- <i class="far fa-file color-theme mr-1"></i> -->
                                                      <span class="badge color-theme">{{ getArquivosPasta(pasta.id).length }} arquivo(s)</span>
                                                   </div>
                                                </div>
                                                <p class="pasta-caminho mt-2">
                                                   <i class="far fa-folder-open color-theme mr-1"></i>
                                                   <span class="text-muted">{{ pasta.caminho }}</span>
                                                </p>
                                             </div>
                                             
                                             <!-- Área de arquivos -->
                                             <div class="cards-1">
                                                <div v-if="getArquivosPasta(pasta.id).length < 100" class="card card-mini border border-dashed cursor-pointer mb-0">
                                                   <div class="card-body text-center py-5">
                                                      <i class="far fa-cloud-upload fa-3x mb-3 text-muted"></i>
                                                      <h6 class="mb-2 text-muted">Arraste e solte arquivos aqui</h6>
                                                      <p class="mb-0 text-muted font-12">ou clique para selecionar arquivos</p>
                                                      <input type="file" :ref="'files-' + pasta.id" accept=".jpg,.jpeg,.png,.gif,.pdf,.doc,.docx,.xls,.xlsx,.txt,.csv,.zip,.rar" @change="showFiles(pasta.id)" multiple style="opacity: 0; position: absolute; top: 0; left: 0; width: 100%; height: 100%; cursor: pointer;"/>
                                                   </div>
                                                </div>
                                                <div v-for="(file, fileIndex) in getArquivosPasta(pasta.id)" :key="fileIndex" class="card mb-0">
                                                   <div class="card-body text-center">
                                                      <i class="far fa-4x mb-3" :class="[file.name ? (file.name.match(/\.(jpg|jpeg|png|gif)$/i) ? 'fa-image' : 'fa-file') : (file.nome.match(/\.(jpg|jpeg|png|gif)$/i) ? 'fa-image' : 'fa-file')]"></i>
                                                      <h6 class="limitador mt-0 mb-2">{{ file.name == null ? file.nome : file.name }}</h6>
                                                      <span class="limitador d-block mb-3">
                                                         <span class="text-secondary">{{ (file.size / 1048576) >= 1 ? (file.size / 1048576).toFixed(1) +"MB" : (file.size / 1024).toFixed(1) +"KB" }}</span>
                                                      </span>
                                                      <button type="button" class="btn btn-default btn-sm px-3 mr-1" @click="visualizarFile(file)" v-if="file.name == null && file.caminho != null">
                                                         <span><i class="far fa-eye" :class="view ? 'mr-md-2' : ''"></i><span class="hidden-md" v-if="view">Visualizar</span></span>
                                                      </button>
                                                      <button type="button" class="btn btn-default btn-sm px-3" @click="removeFile(fileIndex, pasta.id)" v-if="!view">
                                                         <span><i class="far fa-trash" :class="file.name != null && file.caminho == null ? 'mr-md-2' : ''"></i><span class="hidden-md" v-if="file.name != null && file.caminho == null">Deletar</span></span>
                                                      </button>
                                                   </div>
                                                </div>
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="modal-footer">
                  <button type="button" class="btn btn-round btn-secondary" data-dismiss="modal">Fechar</button>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>

import $ from 'jquery'
import { mapState } from 'vuex'
import pasta from '@/components/pastas/Pasta.vue'
import Swal from 'sweetalert2'

export default {
   name: 'Arquivos',
   data: function() {
		return {
         pesquisa: {'valor': '', 'resultado': []},
         pasta: {'id': null, 'nome': '', 'anoReferencia': ''},
         listaPastas: [],
         arquivosPorPasta: {}, // Armazena arquivos de cada pasta mensal
         pastaAtualId: null, // ID da pasta atual selecionada
         view: false
		}
	},
   computed: {
      ... mapState({
         dadosCondominio: state => state.dadosCondominio,
         dadosUsuario: state => state.dadosUsuario,
         urlRest: state => state.urlRest
      })
   },
   components: {
      pasta
   },
   methods: {
      searchArquivos : function () {
         let ref = this;
         this.$store.dispatch('alternarTelaCarregamento', true)
         this.pesquisa.resultado = [];

         this.$axios({
            method: 'get',
            url: this.urlRest +'arquivoMorto',
            params: {
               valor: this.pesquisa.valor
            }
         }).then(response => {
				ref.pesquisa.resultado = response.data.reverse();

         }).catch(function (error) {
            if (error.response != undefined) {
               if (error.response.status == 408) {
                  ref.$store.dispatch('deslogar')

                  ref.$toast.fire({
                     icon: 'warning',
                     title: 'Sessão expirada!'
                  });
               } else {
                  ref.$toast.fire({
                     icon: 'error',
                     title: 'Erro: ' + error.response.status
                  });
               }
            } else {
               ref.$toast.fire({
                  icon: 'error',
                  title: error
               });
            }
         }).finally(() => {
            this.$store.dispatch('alternarTelaCarregamento', false)
         });
      },
      addPasta : function () {
         this.pasta = {'id': null, 'nome': '', 'anoReferencia': ''}
         $('#modalAddPasta').modal('show')
      },
      savePasta : function () {
         if (this.pasta.nome == null || this.pasta.nome.trim().length == 0) {
            this.$toast.fire({
               icon: 'error',
               title: 'Nome da pasta inválido!'
            })

            return
         }

         if (this.pasta.anoReferencia == null || this.pasta.anoReferencia.trim().length != 4) {
            this.$toast.fire({
               icon: 'error',
               title: 'Ano da pasta inválido!'
            })

            return
         }

         let ref = this;
			this.$store.dispatch('alternarTelaCarregamento', true)
         this.$axios({
            method: 'post',
            url: this.urlRest +'arquivoMorto',
            headers: {
					'Content-Type': 'application/json'
            },
				data: this.pasta

         }).then(function () {
            $('#modalAddPasta').modal('hide')
            ref.searchArquivos()

            ref.$toast.fire({
               icon: 'success',
               title: 'Pasta criada!'
            })
         }).catch(function (error) {
            if (error.response != undefined) {
               if (error.response.status == 408) {
                  ref.$store.dispatch('deslogar')

                  ref.$toast.fire({
                     icon: 'warning',
                     title: 'Sessão expirada!'
                  });
               } else {
                  ref.$toast.fire({
                     icon: 'error',
                     title: 'Erro: ' + error.response.status
                  })
               }
            } else {
               ref.$toast.fire({
                  icon: 'error',
                  title: error
               })
            }
         }).finally(() => {
            this.$store.dispatch('alternarTelaCarregamento', false)
         })
      },
      deletePasta : function (id) {
         let ref = this;
         this.$store.dispatch('alternarTelaCarregamento', true)
         this.$axios({
            method: 'delete',
            url: this.urlRest +'arquivoMorto',
            params:{
               id: id
            }

         }).then(function () {
            ref.searchArquivos()

            ref.$toast.fire({
               icon: 'success',
               title: 'Pasta deletada!'
            })

         }).catch(function (error) {
            if (error.response != undefined) {
               if (error.response.status == 408) {
                  ref.$store.dispatch('deslogar')

                  ref.$toast.fire({
                     icon: 'warning',
                     title: 'Sessão expirada!'
                  });
               } else {
                  ref.$toast.fire({
                     icon: 'error',
                     title: 'Erro: ' + error.response.status
                  });
               }
            } else {
               ref.$toast.fire({
                  icon: 'error',
                  title: error
               });
            }
         }).finally(() => {
            this.$store.dispatch('alternarTelaCarregamento', false)
         });
      },
      abrirPasta : function (id) {
         let ref = this;
         this.$store.dispatch('alternarTelaCarregamento', true)
         this.listaPastas = [];
         this.arquivosPorPasta = {};
         this.pastaAtualId = id;

         this.$axios({
            method: 'get',
            url: this.urlRest +'arquivoMorto/getPastasMensais',
            params: {
               id: id
            }
         }).then(response => {
				ref.listaPastas = response.data;
            // Carrega arquivos da primeira pasta (primeira aba)
            if (ref.listaPastas.length > 0) {
               ref.carregarArquivosPasta(ref.listaPastas[0].id);
            }
            // Abre o modal após carregar as pastas
            $('#modalPastasMensais').modal('show');

         }).catch(function (error) {
            if (error.response != undefined) {
               if (error.response.status == 408) {
                  ref.$store.dispatch('deslogar')

                  ref.$toast.fire({
                     icon: 'warning',
                     title: 'Sessão expirada!'
                  });
               } else {
                  ref.$toast.fire({
                     icon: 'error',
                     title: 'Erro: ' + error.response.status
                  });
               }
            } else {
               ref.$toast.fire({
                  icon: 'error',
                  title: error
               });
            }
         }).finally(() => {
            this.$store.dispatch('alternarTelaCarregamento', false)
         });
      },
      getMesNome : function (nomeCompleto) {
         // Extrai o nome do mês do nome completo (ex: "JANEIRO 2020" -> "JAN")
         const meses = {
            'JANEIRO': 'JAN',
            'FEVEREIRO': 'FEV', 
            'MARÇO': 'MAR',
            'ABRIL': 'ABR',
            'MAIO': 'MAI',
            'JUNHO': 'JUN',
            'JULHO': 'JUL',
            'AGOSTO': 'AGO',
            'SETEMBRO': 'SET',
            'OUTUBRO': 'OUT',
            'NOVEMBRO': 'NOV',
            'DEZEMBRO': 'DEZ'
         };
         
         for (let mes in meses) {
            if (nomeCompleto.includes(mes)) {
               return meses[mes];
            }
         }
         return nomeCompleto; // Retorna o nome original se não encontrar correspondência
      },
      carregarArquivosPasta : function (pastaId) {
         let ref = this;
         this.$store.dispatch('alternarTelaCarregamento', true)

         this.$axios({
            method: 'get',
            url: this.urlRest +'arquivoMorto/getArquivos',
            params: {
               id: pastaId
            }
         }).then(response => {
            // Armazena os arquivos na estrutura de dados
            this.$set(this.arquivosPorPasta, pastaId, response.data || []);

         }).catch(function (error) {
            if (error.response != undefined) {
               if (error.response.status == 408) {
                  ref.$store.dispatch('deslogar')

                  ref.$toast.fire({
                     icon: 'warning',
                     title: 'Sessão expirada!'
                  });
               } else {
                  ref.$toast.fire({
                     icon: 'error',
                     title: 'Erro: ' + error.response.status
                  });
               }
            } else {
               ref.$toast.fire({
                  icon: 'error',
                  title: error
               });
            }
         }).finally(() => {
            this.$store.dispatch('alternarTelaCarregamento', false)
         });
      },
      getArquivosPasta : function (pastaId) {
         return this.arquivosPorPasta[pastaId] || [];
      },
      adicionarArquivo : function (pastaId) {
         // Função placeholder - não implementada ainda
         console.log('Adicionar arquivo para pasta:', pastaId);
      },
      showFiles : function (pastaId) {
         const files = this.$refs['files-' + pastaId][0].files;
         
         if (files.length === 0) {
            return;
         }

         // Validação de limite de arquivos
         if ((files.length + this.getArquivosPasta(pastaId).length) > 100) {
            this.$toast.fire({
               icon: 'error',
               title: 'Limite atingido',
               text: 'Máximo de anexos excedido (100).'
            });
            this.$refs['files-' + pastaId][0].value = "";
            return;
         }

         // Validação de tamanho dos arquivos
         for (let file of files) {
            if (file.size >= 10485760) { // 10MB
               this.$toast.fire({
                  icon: 'error',
                  title: 'Tamanho excedido',
                  text: 'Arquivo excede 10MB'
               });
               this.$refs['files-' + pastaId][0].value = "";
               return;
            }
         }

         // Upload dos arquivos
         this.uploadArquivos(files, pastaId);
      },
      uploadArquivos : function (files, pastaId) {
         let ref = this;
         let dataForm = new FormData();
         
         // Adiciona os arquivos ao FormData
         for (let file of files) {
            dataForm.append('file', file, file.name.replace(/[^\w\s.]/gi, ''));
         }
         
         this.$store.dispatch('alternarTelaCarregamento', true);
         this.$axios({
            method: 'post',
            url: this.urlRest + 'arquivoMorto/upload',
            headers: {
               'Content-Type': 'multipart/form-data'
            },
            data: dataForm,
            params: {
               id: pastaId
            }
         }).then(function () {
            // Limpa o input de arquivos
            ref.$refs['files-' + pastaId][0].value = "";
            
            // Recarrega os arquivos da pasta atual
            ref.carregarArquivosPasta(pastaId);
            
            ref.$toast.fire({
               icon: 'success',
               title: 'Arquivo(s) enviado(s) com sucesso!'
            });
         }).catch(function (error) {
            if (error.response != undefined) {
               if (error.response.status == 408) {
                  ref.$store.dispatch('deslogar');
                  ref.$toast.fire({
                     icon: 'warning',
                     title: 'Sessão expirada!'
                  });
               } else {
                  ref.$toast.fire({
                     icon: 'error',
                     title: 'Erro: ' + error.response.status
                  });
               }
            } else {
               ref.$toast.fire({
                  icon: 'error',
                  title: error
               });
            }
         }).finally(() => {
            this.$store.dispatch('alternarTelaCarregamento', false);
         });
      },
      visualizarFile : function (file) {
         const link = document.createElement('a');
         link.href = file.caminho;
         link.target = '_blank';
         link.rel = 'noopener noreferrer';
         document.body.appendChild(link);
         link.click();
         document.body.removeChild(link);
      },
      removeFile : function (fileIndex, pastaId) {
         let ref = this;
         const arquivo = this.getArquivosPasta(pastaId)[fileIndex];
         
         if (!arquivo || !arquivo.id) {
            this.$toast.fire({
               icon: 'error',
               title: 'Arquivo não encontrado!'
            });
            return;
         }

         Swal.fire({
            icon: 'warning',
            title: 'Excluir arquivo',
            confirmButtonText: 'Confirmar',
            showCancelButton: true,
            cancelButtonText: 'Cancelar'
         }).then((result) => {
            if (result.isConfirmed) {
               ref.$store.dispatch('alternarTelaCarregamento', true);
               ref.$axios({
                  method: 'delete',
                  url: ref.urlRest + 'arquivoMorto/deleteArquivo',
                  params: {
                     id: arquivo.id
                  }
               }).then(function () {
                  // Recarrega os arquivos da pasta atual
                  ref.carregarArquivosPasta(pastaId);
                  
                  ref.$toast.fire({
                     icon: 'success',
                     title: 'Arquivo removido com sucesso!'
                  });
               }).catch(function (error) {
                  if (error.response != undefined) {
                     if (error.response.status == 408) {
                        ref.$store.dispatch('deslogar');
                        ref.$toast.fire({
                           icon: 'warning',
                           title: 'Sessão expirada!'
                        });
                     } else {
                        ref.$toast.fire({
                           icon: 'error',
                           title: 'Erro: ' + error.response.status
                        });
                     }
                  } else {
                     ref.$toast.fire({
                        icon: 'error',
                        title: error
                     });
                  }
               }).finally(() => {
                  ref.$store.dispatch('alternarTelaCarregamento', false);
               });
            }
         });
      }
   },
   mounted() {
      $('#search-nav .dropdown-menu').on('click', function(e) {
         if (e.target.nodeName != 'BUTTON') {
            e.stopPropagation();
         }
      });

      // Event listener para troca de abas no modal de pastas mensais
      $('#modalPastasMensais').on('shown.bs.modal', () => {
         // Adiciona listener para troca de abas
         $('#pastasMensaisTabs a[data-toggle="tab"]').on('shown.bs.tab', (e) => {
            const target = $(e.target).attr('href'); // #pasta-0, #pasta-1, etc.
            const index = target.split('-')[1]; // Extrai o índice da aba
            const pastaId = this.listaPastas[index]?.id;
            
            if (pastaId && !this.arquivosPorPasta[pastaId]) {
               // Carrega arquivos apenas se ainda não foram carregados
               this.carregarArquivosPasta(pastaId);
            }
         });
      });

      this.searchArquivos()
   }
}

</script>

<style scoped>

input[type="file"] {
   position: absolute;
   top: 0;
   right: 0;
   min-width: 100%;
   min-height: 100%;
   font-size: 100px;
   text-align: right;
   filter: alpha(opacity=0);
   opacity: 0;
   outline: none;
   background: white;
   cursor: inherit;
   display: block;
}

/* Estilos para as tabs do modal de pastas mensais */
#modalPastasMensais .nav-tabs {
   border-bottom: 2px solid var(--primary-color);
   margin-bottom: 0;
}

#modalPastasMensais .nav-tabs .nav-link {
   color: var(--font-555);
   border: none;
   border-bottom: 3px solid transparent;
   background: transparent;
   padding: 12px 20px;
   font-weight: 500;
   transition: all 0.3s ease;
   border-radius: 0;
}

#modalPastasMensais .nav-tabs .nav-link:hover {
   color: var(--primary-color);
   border-bottom-color: var(--primary-color);
   /* background: var(--hover-bg); */
}

#modalPastasMensais .nav-tabs .nav-link.active {
   color: var(--primary-color);
   border-bottom-color: var(--primary-color);
   /* background: var(--hover-bg); */
   font-weight: 600;
}

#modalPastasMensais .tab-content {
   border: none;
   padding: 0;
   /* background: #fff; */
}

#modalPastasMensais .tab-pane {
   padding: 20px 0;
   padding-top: 0;
}

/* Estilos para o cabeçalho da pasta */
#modalPastasMensais .pasta-header {
   background: var(--hover-bg);
   border-radius: 8px;
   padding: 15px 20px;
   margin-bottom: 20px;
   border-left: 4px solid var(--primary-color);
}

#modalPastasMensais .pasta-header h6 {
   color: var(--primary-color);
   font-weight: 600;
   margin: 0;
}

#modalPastasMensais .pasta-header .badge {
   font-size: 0.85rem;
   padding: 6px 12px;
}

#modalPastasMensais .pasta-caminho {
   font-size: 0.9rem;
   margin: 0;
   /* color: #6c757d; */
}

/* Melhorias na área de upload */
#modalPastasMensais .upload-area {
   border: 2px dashed #dee2e6;
   border-radius: 8px;
   transition: all 0.3s ease;
   /* background: #f8f9fa; */
}

#modalPastasMensais .upload-area:hover {
   border-color: var(--primary-color);
   /* background: #e3f2fd; */
}

/* Melhorias nos cards de arquivos */
#modalPastasMensais .file-card {
   border-radius: 8px;
   border: 1px solid #e9ecef;
   transition: all 0.3s ease;
   background: #fff;
}

#modalPastasMensais .file-card:hover {
   box-shadow: 0 4px 8px rgba(0,0,0,0.1);
   /* transform: translateY(-2px); */
}

</style>